import { ConfigureIntegrationForm } from "@/components/campaign/setup/delivery/ConfigureIntegrationForm";
import { useStepperSubmitHandlerState } from "@/utils/stepper";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_dashboard/campaigns/setup/delivery/integration/configure",
)({
  component: RouteComponent,
  staticData: {
    crumb: "Opsætning",
    meta: {
      title: "Opsætning",
    },
  },
});

function RouteComponent() {
  const context = Route.useRouteContext();
  const stepper = context.useStepper();
  const deliveryContext = stepper.context.delivery;
  if (deliveryContext?.type !== "Integration") throw null;

  const exportSystem = deliveryContext.exportSystem;
  const exportMode = deliveryContext.exportMode;

  const [submitHandler, setSubmitHandler] = useStepperSubmitHandlerState();
  context.stepper.useStepperSubmit(submitHandler);

  return (
    <ConfigureIntegrationForm
      exportSystem={exportSystem}
      exportMode={exportMode}
      defaultValues={{
        exportInput: deliveryContext.exportInput ?? {},
      }}
      updateValues={(values) => {
        stepper.setContext((prev) => {
          if (prev.delivery?.type !== "Integration") return prev;
          return {
            ...prev,
            delivery: {
              ...prev.delivery,
              exportInput: values.exportInput,
            },
          };
        });

        stepper.goNext();
      }}
      setSubmitHandler={setSubmitHandler}
    />
  );
}
